import { Basket, BasketList, DeliveryPolicy, NoBasketSelected, } from 'components/ordering/acl/internal-types.js'


type BasketSelectedState = 'selectable' | 'selected' | 'loading'


export interface BasketListItem {
  basketId: string
  name: string | null
  lineCount: number
  cumulatedCount: number
  selectedState: BasketSelectedState
  deliveryPolicy: DeliveryPolicy
}

const mapToBasketListItem = (basket: Basket, isSelected: boolean): BasketListItem => {
  const selectedState: BasketSelectedState = isSelected ? 'selected' : 'selectable'
  return {
    basketId: basket.basketId,
    name: formatBasketWithNoName(basket),
    lineCount: basket.lineCount,
    cumulatedCount: basket.cumulatedCount,
    selectedState: selectedState,
    deliveryPolicy: basket.deliveryPolicy,
  }
}

export const mapBasketListResponse = (basketsResponse: BasketList): BasketListItem[] => {
  const result = basketsResponse.baskets
  const selectedBasket = basketsResponse.selectedBasket

  const basketList = result.map((basket: Basket) => mapToBasketListItem(basket, isSelected(basket, selectedBasket)))

  return basketList.sort((basketA: BasketListItem, basketB: BasketListItem) => {
    if (basketA.name !== null && basketB.name !== null) {
      return basketA.name.localeCompare(basketB.name)
    }
    return basketA.name === null ? 1 : -1
  })
}

export const mapSelectedBasketFromResponse = (basketsResponse: BasketList): BasketListItem | null => {
  const selectedBasket = basketsResponse.selectedBasket

  if (selectedBasket instanceof NoBasketSelected) return null
  return mapToBasketListItem(selectedBasket, true)
}

const isSelected = (basket: Basket, selectedBasket: Basket | NoBasketSelected): boolean => {
  if (selectedBasket instanceof NoBasketSelected) return false
  return basket.basketId === selectedBasket.basketId
}

const formatBasketWithNoName = (basket: any): string | null => {
  if (typeof (basket.name) === 'string') {
    return basket.name
  }
  return null
}
